<template>
    <div>
        <div v-if="showData()">
          <ul role="list" class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 " :class="cols ? colsClass() : 'lg:grid-cols-3 xl:grid-cols-4  xl:grid-cols-5'">
            
            <li v-for="row in dataRows" :key="row.id"
                :class="[
                    'card',
                    inative(row.status) ? 'opacity-60' : '',
                    searchSelected(row.id) ? 'isSelected' : ''
                ]"
                @click="show($event, row)">
                <UserCardMicro v-if="cardSize == 'xs'" :row="row" :status="inative(row.status)"/>
                <UserCardSmall v-else-if="cardSize == 'sm' || !cardSize" :row="row" :status="inative(row.status)"/>
                <UserCardMedium v-else-if="cardSize == 'md'" :row="row" :status="inative(row.status)"/>
            </li>
            
          </ul>
        </div>

        <div v-else>
            <Cell :p="false" :b="true">
                <noData type="user_cards" />
            </Cell>
        </div>
    </div>
</template>

<script>

import UserCardSmall from './_partials/UserCardSmall.vue';
import UserCardMicro from './_partials/UserCardMicro.vue';
import UserCardMedium from './_partials/UserCardMedium.vue';



export default {
    name: "ListUsersCard",
    props: {
        dataRows: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            required: false
        },
        show: {
            type: Function,
            required: false
        },
        cols: {
            type: Number,
            default: 3,
            required: false
        },
        colsForce: {
            type: Boolean,
            default: false,
            required: false
        },
        cardSize: {
            type: String,
            default: 'sm',
            required: false
        },

    },
    components: {
        UserCardSmall,
        UserCardMicro,
        UserCardMedium,
    },
    methods: {
        showData(){
            try{
                if(this.dataRows.length){
                    return true;
                }
                return false 
            } catch(e){
                return false;
            }            
        },
        colsClass(){

            if(this.cols == 1 ){
                if(this.colsForce){
                    return 'grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1';
                }
                return 'grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1';
            }
            if(this.cols == 2 ){
                if(this.colsForce){
                    return 'grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2';
                }                
                return 'grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2';
            }            
            if(this.cols == 3 ){
                if(this.colsForce){
                    return 'grid-cols-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3';
                }                
                return 'grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3';
            }   
            if(this.cols == 4 ){
                if(this.colsForce){
                    return 'grid-cols-4 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4';
                }
                return 'grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4';
            }   

        },
        rounded(){

            if(this.cardSize && this.cardSize == 'xs'){
                return 'rounded-full';
            }
            else {
                return 'rounded-lg';
            }

        },

        inative(status){
            if(status == 'inative'){
                return true;
            }
            return false;
        },
        processAttribute(key, attribute) {
            return Attributs.process(key, attribute); 
        },
        searchSelected(id) {        
            return this.selected.indexOf(id) > -1;
        },
    },    
}

</script>

<style scoped>

.card {
    @apply rounded-lg cursor-pointer col-span-1 flex flex-col text-center bg-white border border-gray-200 transition-all duration-200 hover:shadow-md hover:border-gray-400;
}

.isSelected {
    @apply bg-gray-50 border-2 border-gray-800;
}

</style>